import React from 'react';

import WordLabelDelete from './WordLabelDelete/WordLabelDelete';
import { Wrapper, Count } from './styled/WordLabelStyled';

interface WordLabelProps {
    children: string;
    isClickable?: boolean;
    count?: number;
    onWordClick?: (name: string) => void;
    pillType?: string;
}

function WordLabel(props: WordLabelProps) {
    return (
        <Wrapper data-testid="WordLabel" $pillType={props.pillType || ''} $clickable={Boolean(props.onWordClick && props.isClickable)}>
            {props.children}
            {props.onWordClick && props.isClickable && <WordLabelDelete onClick={props.onWordClick} name={props.children} />}
            {props.count && (props.pillType || '').includes('blacklist') ? <Count>{props.count}x</Count> : null}
        </Wrapper>
    );
}

export default WordLabel;
